/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-children-prop */
import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useStyles from '../../assets/styles/pages/SignUp';
import Header from '../../components/Header';

// import svg
import { ReactComponent as IconArrow } from '../../assets/images/svg/sign_up/icon_seta_r.svg';
import { ReactComponent as IconEmail } from '../../assets/images/svg/sign_up/icon_email.svg';
import { ReactComponent as IconPhone } from '../../assets/images/svg/sign_up/icon_phone.svg';
import { ReactComponent as IconPassword } from '../../assets/images/svg/sign_up/icon_senha.svg';
import { ReactComponent as IconUser } from '../../assets/images/svg/sign_up/icon_user.svg';
import { ReactComponent as IconInfo } from '../../assets/images/svg/utils/info.svg';
import { ReactComponent as IndicationUser } from '../../assets/images/svg/sign_up/indique_ganhe.svg';

import imgCpf from '../../assets/images/cpf.png';

import FooterMenuMain from '../../components/FooterMenuMain';
import { useLoadingContext } from '../../providers/use-loading';
import { useSignInContext } from '../../providers/use-signin';
import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import { getStorege } from '../../helpers/db_storage';
import { useSignUpContext } from '../../providers/use-signup';
import {
  FormatCpf,
  onlyNumbers,
  validateCpf,
} from '../../helpers/utils/Formating';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

const SignUp: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const signUpContext = useSignUpContext();
  const { params, id_shop }: any = useParams();
  const { search } = useLocation();
  const variavelGet = new URLSearchParams(search);
  const getId = variavelGet.get('id');

  const { createloading } = useLoadingContext();
  const { signing, signingSaveLocal, data } = useSignInContext();

  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [disableInputCodeIndication, setDisableInputCodeIndication] =
    useState(false);
  const [errorInfo, setErrorInfo] = useState('');
  const [formParams, setFormParams] = useState({
    nr_operacao: 8,
    idUsuario: '',
    dsNome: '',
    dsEmail: '',
    nrDDD: '',
    nrTelefone: '',
    dsSenha: '',
    dsRepitaSenha: '',
    codeIndication: '',
    retornoTipo: '',
    idAuthG: '',
    dsCpf: '',
  });

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const handleChangeForm = (event: any) => {
    const { name } = event.target;
    let { value } = event.target;

    if (name === 'dsCpf') {
      value = onlyNumbers(value);

      if (value.length > 11) {
        return;
      }
    }

    if (name === 'codeIndication') {
      setFormParams((field) => {
        return {
          ...field,
          [`${name}`]: value.toLocaleUpperCase(),
        };
      });
      return;
    }

    setFormParams((field) => {
      return {
        ...field,
        [`${name}`]: value,
      };
    });
  };

  const handleSubimt = async (event: SyntheticEvent) => {
    event.preventDefault();
    if (
      formParams.dsNome === '' ||
      formParams.dsEmail === '' ||
      ((formParams.dsSenha === '' || formParams.dsRepitaSenha === '') &&
        formParams?.retornoTipo !== 'C') ||
      formParams.nrDDD === '' ||
      formParams.nrTelefone === ''
    ) {
      setErrorInfo('Todas as informações são obrigatórias');
      setOpenUserNotParams(true);
      return;
    }

    if (formParams?.dsCpf) {
      if (!validateCpf(formParams.dsCpf)) {
        setErrorInfo('CPF inválido');
        setOpenUserNotParams(true);
        return;
      }
    }

    if (formParams.nrTelefone.length > 9 || formParams.nrDDD.length > 3) {
      setErrorInfo('Número de telefone inválido');
      setOpenUserNotParams(true);
      return;
    }

    if (
      formParams.dsSenha !== formParams.dsRepitaSenha &&
      formParams?.retornoTipo !== 'C'
    ) {
      setErrorInfo('As senhas devem ser iguais');
      setOpenUserNotParams(true);
      return;
    }

    createloading(true);

    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.signUp(
        formParams,
      );

      createloading(false);
      if (result.data.retorno === 'OK') {
        setErrorInfo(result.data.mensagem || 'Conta criada com sucesso!');
        setOpenUserNotParams(true);

        if (formParams.retornoTipo === 'C') {
          signingSaveLocal(result.data);
          return;
        }

        signing({
          dsEmail: formParams.dsEmail,
          dsSenha: formParams.dsSenha,
          dsTipo: 'email',
        });
      } else {
        if (
          result.data.mensagem ==
          'Não foi possível validar o código de indicação. Caso não tenha o código correto, deixe o campo em branco.'
        ) {
          setDisableInputCodeIndication(false);
          setFormParams((field) => {
            return {
              ...field,
              [`codeIndication`]: '',
            };
          });
        }
        setOpenUserNotParams(true);
        setErrorInfo(result.data.mensagem);
      }
    } catch (error) {
      toast.error('Ocorreu um erro ao criar sua conta, tente novamente');
    }
  };

  useEffect(() => {
    async function redirectPage() {
      await new Promise((resolve) => {
        setTimeout(resolve, 4000);
      });

      if (data.return === 'NOK') {
        toast.error('Não foi possível acessar sua conta, tente novamente');
        handleToPage('/sign/in');
      }

      if (data.return === 'OK' && params && id_shop) {
        toast.success('Finalize seu pedido');
        handleToPage(`/shop/request/detail/${id_shop}`);
        return;
      }

      if (data.return === 'OK') {
        handleToPage('/dashboard/user/address/create?user=1');
      }
    }
    redirectPage();
  }, [data]);

  useEffect(() => {
    const result = getStorege('@mais/delivery/user/create');

    setFormParams((field) => {
      return {
        ...field,
        [`dsEmail`]: result.dsEmail,
        [`nrDDD`]: result.nrDDD,
        [`nrTelefone`]: result.nrTelefone,
        [`dsNome`]: result?.dsNome,
        [`retornoTipo`]: result?.retornoTipo,
        [`idAuthG`]: result?.idAuth,
      };
    });
  }, []);

  useEffect(() => {
    if (getId) {
      setDisableInputCodeIndication(true);
      setFormParams((field) => {
        return {
          ...field,
          [`codeIndication`]: getId.toLocaleUpperCase(),
        };
      });
    }
  }, [getId]);

  useEffect(() => {
    signUpContext.cleanData();

    const result = getStorege('@mais/delivery/user/create');

    if (
      (typeof result?.phoneValid == 'undefined' ||
        result?.emailValid != 'true') &&
      (typeof result?.phoneValid == 'undefined' || result?.phoneValid != 'true')
    ) {
      handleToPage('/sign/up/user');
    }
  }, []);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="SignUp" />

      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          className={classeStyle.gridForm}
        >
          <h3>Cadastre-se</h3>
          <form onSubmit={handleSubimt} className={classeStyle.form}>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>Nome</label>
              <IconUser className={classeStyle.icon} />
              <input
                type="text"
                className={classeStyle.inputText}
                placeholder="Digite seu nome completo"
                name="dsNome"
                value={formParams.dsNome}
                onChange={handleChangeForm}
              />
            </Grid>

            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>E-mail</label>
              <IconEmail className={classeStyle.icon} />
              <input
                type="text"
                className={classeStyle.inputText}
                placeholder="exemplo@mail.com"
                style={{ background: '#ebe0e0' }}
                name="dsEmail"
                readOnly
                value={formParams.dsEmail}
                onChange={handleChangeForm}
              />
            </Grid>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>Telefone</label>
              <IconPhone className={classeStyle.icon} />
              <Grid container item>
                <Grid item xs={4} marginLeft="0px">
                  <input
                    type="text"
                    className={classeStyle.inputText}
                    placeholder="DDD"
                    style={{ background: '#ebe0e0' }}
                    value={formParams.nrDDD}
                    readOnly
                    name="nrDDD"
                    size={3}
                    maxLength={3}
                    onChange={handleChangeForm}
                  />
                </Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    className={classeStyle.inputText}
                    placeholder="+ Telefone"
                    style={{ background: '#ebe0e0' }}
                    readOnly
                    size={9}
                    maxLength={9}
                    value={formParams.nrTelefone}
                    name="nrTelefone"
                    onChange={handleChangeForm}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>CPF (opcional)</label>
              <img
                className={classeStyle.icon}
                style={{ width: 20, marginRight: 10 }}
                src={imgCpf}
                alt="icon"
              />
              <input
                type="text"
                className={classeStyle.inputText}
                placeholder="Opcional"
                maxLength={14}
                name="dsCpf"
                value={FormatCpf(formParams.dsCpf)}
                onChange={handleChangeForm}
              />
            </Grid>
            {(!formParams.retornoTipo || formParams.retornoTipo !== 'C') && (
              <>
                <Grid
                  container
                  item
                  justifyContent="flex-start"
                  alignItems="center"
                  textAlign="center"
                >
                  <label className={classeStyle.labelText}>Senha</label>
                  <IconPassword className={classeStyle.icon} />
                  <input
                    type="password"
                    className={classeStyle.inputText}
                    placeholder="A senha deve conter pelo menos 8 caracteres"
                    name="dsSenha"
                    value={formParams.dsSenha}
                    onChange={handleChangeForm}
                  />
                </Grid>
                <Grid
                  container
                  item
                  justifyContent="flex-start"
                  alignItems="center"
                  textAlign="center"
                >
                  <label className={classeStyle.labelText}>
                    Confirme sua senha
                  </label>
                  <IconPassword className={classeStyle.icon} />
                  <input
                    type="password"
                    className={classeStyle.inputText}
                    placeholder="Repita a sua senha"
                    name="dsRepitaSenha"
                    value={formParams.dsRepitaSenha}
                    onChange={handleChangeForm}
                  />
                </Grid>
              </>
            )}
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>
                Código de indicação (Opcional)
              </label>
              <IndicationUser className={classeStyle.icon} />
              <input
                readOnly={disableInputCodeIndication}
                style={
                  disableInputCodeIndication ? { background: '#ebe0e0' } : {}
                }
                type="text"
                className={classeStyle.inputText}
                placeholder="Se tiver um código, digite aqui."
                name="codeIndication"
                value={formParams.codeIndication}
                onChange={handleChangeForm}
              />
            </Grid>
            <Grid
              container
              item
              justifyContent="center"
              alignItems="center"
              textAlign="center"
            >
              <Button
                className={classeStyle.btnSubmit}
                type="submit"
                variant="contained"
              >
                Cadastrar <IconArrow className={classeStyle.iconSave} />
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
      <FooterMenuMain />
      <Modal
        open={openUserNotParams}
        onClose={() => setOpenUserNotParams(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '550px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              Atenção!
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {errorInfo}
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnModal}
            onClick={() => setOpenUserNotParams(false)}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default SignUp;
